import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  blogs = [

    {
      id: 1,
      category: 'Solar Guide',
      date: 'August 18, 2026',
      title: 'How Does a Rooftop Solar System Work?',
      shortDescription:
        'Understand how solar panels generate electricity and how solar power can be used for your home or business.',
      image: 'assets/image/home.png',
    },

    {
      id: 2,
      category: 'Solar Systems',
      date: 'August 15, 2026',
      title:
        'On-Grid, Off-Grid or Hybrid: Which Solar System Is Right for You?',
      shortDescription:
        'Compare different solar system types and understand which solution may suit your energy requirements.',
      image: 'assets/image/about-1.png',
    },

    {
      id: 3,
      category: 'Solar Savings',
      date: 'August 12, 2026',
      title:
        'What Should You Consider Before Installing Solar?',
      shortDescription:
        'Learn about electricity usage, rooftop space, system sizing, installation, and other important factors before going solar.',
      image: 'assets/image/home2.png',
    }

  ];
}
